import { render, staticRenderFns } from "./stepsCarousel.vue?vue&type=template&id=29ddbf19&scoped=true&"
import script from "./stepsCarousel.vue?vue&type=script&lang=js&"
export * from "./stepsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./stepsCarousel.vue?vue&type=style&index=0&id=29ddbf19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ddbf19",
  null
  
)

export default component.exports